import { render, staticRenderFns } from "./VideoSelect.vue?vue&type=template&id=4bcd5807&"
import script from "./VideoSelect.vue?vue&type=script&lang=ts&"
export * from "./VideoSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports